import { getAlerts, getMetar } from './getData.js'
import { map } from './layers-init.js'

// POP-UP DATA EVENTS
const popupAlertType = (type, evt) => {
  const popup = L.popup()
  let popupContents = ''
  
  const lat = evt.latlng.lat
  const lon = evt.latlng.lng
  
  Promise.all([getAlerts(type, lat, lon), getMetar(lat, lon)])
    .then(results => {
      const allAlerts = results[0].alert.data
      const temperature = Math.round(results[1].metars.data.temperature.value * 9/5 + 32).toString() + '&deg;'
  
      // Clear previous popup contents
      popupContents = ''
      
      // Initialize empty container for watch/warning/advisory data
      // let wwa = ''
      if (allAlerts.length > 0) {
        allAlerts.map(alert => {
          popupContents += '<b>' + alert.type + '</b>' + '<hr />'

          // Show full alert bulletin in a div
          // let rawText = alert.text
          // let mainText = rawText.split('&&')[0]
          // wwa += mainText.replace(/\n/gm, '<br />')
          // document.getElementById('alert-text').innerHTML = wwa
          // wwa += '<hr>'
        })
      } else {
        document.getElementById('alert-text').innerHTML = ''
      }

      // Add temperature to the popup
      popupContents += '<b>' + 'Temperature:' + '</b>&nbsp;' + temperature

      // Display popup on map that displays the alert type when user clicks
      popup.setLatLng(evt.latlng).setContent(popupContents).openOn(map)

      // Pan to the location where the user clicked so alert text div doesn't cover up the location of the warning on the map 
      map.panTo([lat, lon])
    })
    .catch(_ => console.log('Error retrieving data for the leaflet popup'))
}

export { popupAlertType }